import { useFetchLatestAppoinmentResults } from '@/api/hooks/useFetchLatestAppointmentResults'
import { ViewableAppointmentResults } from '@/components/AppointmentResultsPage/ViewableAppointmentResults'
import ProtectedPage from '@/components/ProtectedPage'
import { markResultsSeen } from '@/features/home/resultsSeen'
import { analytics } from '@/lib/analytics'
import { PhotoBlock } from '@/ui/core/block'
import { Button, ButtonText } from '@/ui/core/button'
import { FlowHeader } from '@/ui/core/flow-header'
import { Header } from '@/ui/core/header'
import { PageShell } from '@/ui/core/page-shell'
import { Screen } from '@/ui/core/screen'
import { Skeleton } from '@/ui/core/skeleton'
import { VStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'
import { router } from 'expo-router'
import { useEffect } from 'react'
import Images from '#/assets/images/image-map'

const goBack = () => (router.canGoBack() ? router.back() : router.replace('/'))

const LockedScore = () => (
	<VStack gap={0}>
		<PhotoBlock source={Images.Bubbles} height={200} scrim={0.2}>
			<Header variant="h1" tone="white">
				Your score
			</Header>
		</PhotoBlock>
		<VStack gap={16} className="pt-6 pb-8">
			<Header variant="h3">Not yet, but soon.</Header>
			<Text className="max-w-[28rem]">
				Your score is built from your first visit: X-rays, scans and a look from your
				clinician. It lands here the same day.
			</Text>
		</VStack>
		<Button
			variant="secondary"
			fullWidth={false}
			onPress={() => router.navigate('/care')}
		>
			<ButtonText>See your care</ButtonText>
		</Button>
	</VStack>
)

export default function ScoreScreen() {
	const { hasLockedResults, hasAppointmentResults, isLoadingResults, appointmentId } =
		useFetchLatestAppoinmentResults()

	useEffect(() => {
		if (isLoadingResults) {
			return
		}
		analytics.trackEvent('viewed-appointment-results', {
			appointmentId: appointmentId ?? 'none',
			hasLockedResults: hasLockedResults?.valueOf() ?? false,
		})
		if (appointmentId !== undefined) {
			markResultsSeen(appointmentId)
		}
	}, [appointmentId, hasLockedResults, isLoadingResults])

	return (
		<ProtectedPage>
			<Screen preset="fixed" className="flex flex-1" safeAreaEdges={['top']}>
				<FlowHeader onBack={goBack} />
				{/* The report owns the space under the header, so the card can run to the bottom
				    and scroll inside itself. Waiting for a score, the page scrolls as pages do. */}
				<PageShell
					flush
					scroll={!hasAppointmentResults}
					photo={Images.BrandPhoto}
					contentClassName={hasAppointmentResults ? 'px-0 pb-0' : undefined}
				>
					<Skeleton isLoading={isLoadingResults} className="mt-8 h-40 w-full">
						{hasAppointmentResults ? <ViewableAppointmentResults /> : <LockedScore />}
					</Skeleton>
				</PageShell>
			</Screen>
		</ProtectedPage>
	)
}
